import pricing from "./pricing.json";

export interface PricingItem {
  id: string;
  name: string;
  price: string;
  description?: string;
  note?: string;
  truckSpace?: string;
  examples?: string[];
  imagePlaceholder?: string;
  color?: string;
}

export interface ServicePricing {
  id: string;
  title: string;
  displayPrice: string;
  label?: string;
  description?: string;
}

export interface PricingData {
  generalLoad: PricingItem[];
  specialtyItems: PricingItem[];
  demolitionServices: PricingItem[];
  services: Record<string, ServicePricing>;
  updatedAt: string;
}

export const defaultPricing = pricing as PricingData;
